/**
 * Rows in the shape of the list they stand in for while it loads (Nov 4 2026): a logo disc, two lines of text and a
 * figure per further column, shimmering (the .skeleton style). A spinner said "wait"; these say what is coming and hold
 * the height, so nothing jumps when the rows land. The figures are left out on a phone, where the list shows fewer.
 */
export function SkeletonRows({ rows = 3, columns = 4 }: { rows?: number; columns?: number }) {
  return (
    <div aria-busy="true" className="divide-y divide-line">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-3 sm:px-6">
          <span className="skeleton size-7 shrink-0 !rounded-full" />
          <span className="grid flex-1 gap-1.5">
            <span className="skeleton h-3.5 w-24" />
            <span className="skeleton h-3 w-16" />
          </span>
          {Array.from({ length: columns }, (_, j) => (
            <span key={j} className="skeleton hidden h-3.5 w-16 sm:block" />
          ))}
        </div>
      ))}
    </div>
  )
}

/** a detail view's body while it loads: a header line, two lines of text and a block */
export function SkeletonDetail() {
  return (
    <div aria-busy="true" className="grid gap-4">
      <span className="skeleton h-6 w-40" />
      <span className="skeleton h-4 w-2/3" />
      <span className="skeleton h-4 w-1/2" />
      <span className="skeleton h-24 w-full" />
    </div>
  )
}
